import { render, staticRenderFns } from "./approvalItemEdit.vue?vue&type=template&id=7d5c4ffc&scoped=true&"
import script from "./approvalItemEdit.vue?vue&type=script&lang=js&"
export * from "./approvalItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./approvalItemEdit.vue?vue&type=style&index=0&id=7d5c4ffc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5c4ffc",
  null
  
)

export default component.exports